/** Helper to draw a Photoshop-style checkerboard background */
export function FN_CANVAS__draw_checker_board(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  //
  w: number,
  h: number,
  //
  size: number = 10,
  //
  color1: string = '#1e1e1e',
  color2: string = '#2d2d2d',
) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(x, y, w, h);
  ctx.clip();

  for (let i = x; i < x + w; i += size) {
    for (let j = y; j < y + h; j += size) {
      ctx.fillStyle = (i / size + j / size) % 2 === 0 ? color1 : color2;
      ctx.fillRect(i, j, size, size);
    }
  }
  ctx.restore();
}
